import { apiUrl } from "../apiClient";
import httpOption from "../httpOption";
import { postLoginAction } from "../nitroService";
import { loginSucceeded } from "../authAnalyticsService";
import { setCurrentUser } from "./currentUser";
import { getApiBearerToken } from "./tokenService";
import { LOGIN_MARKS, markLoginEvent } from "../perf/loginTimeline";

// Thrown specifically when the API returns 403 due to an expired account.
// Callers distinguish this from generic bootstrap failures to avoid retrying
// and to surface a meaningful error to the user.
export class AccountExpiredError extends Error {
  constructor() {
    super("Your account has expired. Please contact support.");
    this.name = "AccountExpiredError";
  }
}

const handleUserData = async (forgeRockUserData, accessToken) => {
  // Backend normalizes ForgeRock profile into Engage session user shape.
  const url = apiUrl("/handleUserData");
  const options = httpOption.POST();
  options.headers.Authorization = `Bearer ${accessToken}`;
  options.body = JSON.stringify({
    forgeRockUserData,
  });

  // Local/dev only. Bracketing the fetch rather than the exported callers so
  // both getUserData and getUserDataApp are covered, and so a retried identity
  // bootstrap shows up as a second pair in the timeline instead of silently
  // inflating one span — the plan lists that retry as a suspected hidden cost.
  markLoginEvent(LOGIN_MARKS.USER_DATA_REQUESTED);
  const response = await fetch(url, options);
  markLoginEvent(LOGIN_MARKS.USER_DATA_RESOLVED);

  if (response.ok) {
    return response.json();
  }

  const errorData = await response.json();
  if (response.status === 403) {
    throw new AccountExpiredError();
  }
  throw new Error(errorData.error);
};

export async function getUserData(userManager) {
  const user = await userManager.getUser();
  // Read through getApiBearerToken rather than off `user` directly, so the
  // provider-specific choice of token lives in exactly one place. The user is
  // already in storage by now — signinRedirectCallback stores it before it
  // resolves — so this sees the token from the sign-in that just completed.
  const sessionUserData = await handleUserData(
    user.profile,
    getApiBearerToken(),
  );
  setCurrentUser(sessionUserData);
  postLoginAction();
  loginSucceeded();
}

export async function getUserDataApp(forgeRockUserData) {
  const accessToken = getApiBearerToken();
  const sessionUserData = await handleUserData(forgeRockUserData, accessToken);
  setCurrentUser(sessionUserData);
  postLoginAction();
  loginSucceeded();
}
